import * as i0 from '@angular/core';
import { EventEmitter, Component, Directive, Input, Output, HostBinding, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import * as i1$1 from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as i2 from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

class ConfirmModalComponent {
    constructor() {
        this.confirm = new EventEmitter();
        this.close = new EventEmitter();
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ConfirmModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.1", type: ConfirmModalComponent, selector: "fgbcl-confirm-modal", ngImport: i0, template: "<div class=\"d-block confirm-modal\">\r\n  <div *ngIf=\"imageRef\" class=\"modal-image flex-grow-0 flex-shrink-0\">\r\n    <ng-container [ngTemplateOutlet]=\"imageRef\"></ng-container>\r\n  </div>\r\n  <ng-container *ngIf=\"headerContent\">\r\n    <div class=\"confirm-modal-header d-flex align-items-center border-bottom\">\r\n      <ng-container *ngIf=\"headerContent.icon\">\r\n        <span class=\"material-icons fw-bold font-size-18 me-2\" aria-hidden=\"true\">{{ headerContent.icon }}</span>\r\n      </ng-container>\r\n      <h5 class=\"fw-bold mb-0\">{{ headerContent.data }}</h5>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <div class=\"d-flex flex-column justify-content-between flex-grow-1 flex-shrink-1\">\r\n    <div class=\"modal-body\">\r\n      <ng-container [ngTemplateOutlet]=\"modalContent\" [ngTemplateOutletContext]=\"{ $implicit: context }\"></ng-container>\r\n    </div>\r\n    <div class=\"modal-footer d-flex justify-content-end\">\r\n      <button type=\"button\" class=\"btn btn-cancel\" (click)=\"close.emit('close')\">\r\n        {{ 'confirm.modal.cancel' | translate }}\r\n      </button>\r\n      <button type=\"button\" class=\"btn btn-confirm\" (click)=\"confirm.emit('confirm')\">\r\n        {{ 'confirm.modal.submit' | translate }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".modal-image{width:390px;height:390px}@media (max-width: 991px){.modal-image{width:100%;height:340px}}.confirm-modal-header{padding:20px}.confirm-modal-header h5,.modal-body,.modal-footer{font-size:14px}.modal-body{padding:1rem 0}button:hover{color:#fff}.modal-footer button{max-width:142px;width:100%;font-size:.875rem}.modal-footer{padding:0 15px;display:flex;align-items:center;height:54px;border-top:1px solid rgba(0,0,0,.125)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ConfirmModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-confirm-modal', template: "<div class=\"d-block confirm-modal\">\r\n  <div *ngIf=\"imageRef\" class=\"modal-image flex-grow-0 flex-shrink-0\">\r\n    <ng-container [ngTemplateOutlet]=\"imageRef\"></ng-container>\r\n  </div>\r\n  <ng-container *ngIf=\"headerContent\">\r\n    <div class=\"confirm-modal-header d-flex align-items-center border-bottom\">\r\n      <ng-container *ngIf=\"headerContent.icon\">\r\n        <span class=\"material-icons fw-bold font-size-18 me-2\" aria-hidden=\"true\">{{ headerContent.icon }}</span>\r\n      </ng-container>\r\n      <h5 class=\"fw-bold mb-0\">{{ headerContent.data }}</h5>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <div class=\"d-flex flex-column justify-content-between flex-grow-1 flex-shrink-1\">\r\n    <div class=\"modal-body\">\r\n      <ng-container [ngTemplateOutlet]=\"modalContent\" [ngTemplateOutletContext]=\"{ $implicit: context }\"></ng-container>\r\n    </div>\r\n    <div class=\"modal-footer d-flex justify-content-end\">\r\n      <button type=\"button\" class=\"btn btn-cancel\" (click)=\"close.emit('close')\">\r\n        {{ 'confirm.modal.cancel' | translate }}\r\n      </button>\r\n      <button type=\"button\" class=\"btn btn-confirm\" (click)=\"confirm.emit('confirm')\">\r\n        {{ 'confirm.modal.submit' | translate }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".modal-image{width:390px;height:390px}@media (max-width: 991px){.modal-image{width:100%;height:340px}}.confirm-modal-header{padding:20px}.confirm-modal-header h5,.modal-body,.modal-footer{font-size:14px}.modal-body{padding:1rem 0}button:hover{color:#fff}.modal-footer button{max-width:142px;width:100%;font-size:.875rem}.modal-footer{padding:0 15px;display:flex;align-items:center;height:54px;border-top:1px solid rgba(0,0,0,.125)}\n"] }]
        }], ctorParameters: () => [] });

class ConfirmModalDirective {
    get isDisabled() {
        return this.disabled ? '' : null;
    }
    constructor(modalService) {
        this.modalService = modalService;
        this.destroy$ = new Subject();
        this.disabled = false;
        this.valid = true;
        this.confirm = new EventEmitter();
    }
    onClick() {
        if (!this.disabled) {
            this.modal = this.modalService.open(ConfirmModalComponent, {
                size: !!this.confirmImage ? 'lg' : undefined,
                centered: true,
                windowClass: this.className,
            });
            this.modalComponent = this.modal.componentInstance;
            this.modalComponent.modalContent = this.confirmContent;
            this.modalComponent.context = this.confirmContext;
            this.modalComponent.imageRef = this.confirmImage;
            this.modalComponent.headerContent = this.confirmHeader;
            this.modalComponent.close.pipe(takeUntil(this.destroy$)).subscribe((x) => this.modal.close(x));
            this.modalComponent.confirm.pipe(takeUntil(this.destroy$)).subscribe((x) => {
                this.confirm.emit(x);
                this.modal.close(x);
            });
        }
    }
    ngOnChanges(changes) {
        if (!this.valid) {
            this.modal.close();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ConfirmModalDirective, deps: [{ token: i1$1.NgbModal }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.2.1", type: ConfirmModalDirective, selector: "[confirmModal]", inputs: { disabled: "disabled", confirmImage: "confirmImage", confirmContent: "confirmContent", confirmContext: "confirmContext", className: ["modal-class", "className"], valid: "valid", confirmHeader: "confirmHeader" }, outputs: { confirm: "confirm" }, host: { listeners: { "click": "onClick()" }, properties: { "attr.disabled": "this.isDisabled" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ConfirmModalDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line: directive-selector
                    selector: '[confirmModal]',
                }]
        }], ctorParameters: () => [{ type: i1$1.NgbModal }], propDecorators: { disabled: [{
                type: Input
            }], confirmImage: [{
                type: Input
            }], confirmContent: [{
                type: Input
            }], confirmContext: [{
                type: Input
            }], className: [{
                type: Input,
                args: [{ alias: 'modal-class' }]
            }], valid: [{
                type: Input
            }], confirmHeader: [{
                type: Input
            }], confirm: [{
                type: Output
            }], isDisabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class ConfirmModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ConfirmModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.1", ngImport: i0, type: ConfirmModalModule, declarations: [ConfirmModalComponent, ConfirmModalDirective], imports: [CommonModule,
            FormsModule,
            NgbModule,
            FGBSharedModule], exports: [ConfirmModalComponent, ConfirmModalDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ConfirmModalModule, imports: [CommonModule,
            FormsModule,
            NgbModule,
            FGBSharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: ConfirmModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ConfirmModalComponent, ConfirmModalDirective],
                    imports: [
                        CommonModule,
                        FormsModule,
                        NgbModule,
                        FGBSharedModule
                    ],
                    exports: [ConfirmModalComponent, ConfirmModalDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ConfirmModalComponent, ConfirmModalDirective, ConfirmModalModule };
